// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! * Quill Editor v2.0.3 * https://quilljs.com * Copyright (c) 2017-2024, Slab * Copyright (c) 2014, Jason Chen * Copyright (c) 2013, salesforce.com */
.ql-container{
    box-sizing:border-box;
    font-family:Helvetica,Arial,sans-serif;
    font-size:13px;
    height:100%;
    margin:0;
    position:relative
}
.ql-container.ql-disabled .ql-tooltip{
    visibility:hidden
}
.ql-container:not(.ql-disabled) li[data-list=checked] > .ql-ui,.ql-container:not(.ql-disabled) li[data-list=unchecked] > .ql-ui{
    cursor:pointer
}
.ql-clipboard{
    left:-100000px;
    height:1px;
    overflow-y:hidden;
    position:absolute;
    top:50%
}
.ql-clipboard p{
    margin:0;
    padding:0
}
.ql-editor{
    box-sizing:border-box;
    counter-reset:list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
    line-height:1.42;
    height:100%;
    outline:none;
    overflow-y:auto;
    padding:12px 15px;
    tab-size:4;
    -moz-tab-size:4;
    text-align:left;
    white-space:pre-wrap;
    word-wrap:break-word
}
.ql-editor > *{
    cursor:text
}
.ql-editor p,.ql-editor ol,.ql-editor pre,.ql-editor blockquote,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6{
    margin:0;
    padding:0
}
@supports (counter-set:none){
    .ql-editor p,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6{
        counter-set:list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9
    }
}
@supports not (counter-set:none){
    .ql-editor p,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6{
        counter-reset:list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9
    }
}
.ql-editor table{
    border-collapse:collapse
}
.ql-editor td{
    border:1px solid #000;
    padding:2px 5px
}
.ql-editor ol{
    padding-left:1.5em
}
.ql-editor li{
    list-style-type:none;
    padding-left:1.5em;
    position:relative
}
.ql-editor li > .ql-ui:before{
    display:inline-block;
    margin-left:-1.5em;
    margin-right:.3em;
    text-align:right;
    white-space:nowrap;
    width:1.2em
}
.ql-editor li[data-list=checked] > .ql-ui,.ql-editor li[data-list=unchecked] > .ql-ui{
    color:#777
}
.ql-editor li[data-list=bullet] > .ql-ui:before{
    content:'\\2022'
}
.ql-editor li[data-list=checked] > .ql-ui:before{
    content:'\\2611'
}
.ql-editor li[data-list=unchecked] > .ql-ui:before{
    content:'\\2610'
}
@supports (counter-set:none){
    .ql-editor li[data-list]{
        counter-set:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9
    }
}
@supports not (counter-set:none){
    .ql-editor li[data-list]{
        counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9
    }
}
.ql-editor li[data-list=ordered]{
    counter-increment:list-0
}
.ql-editor li[data-list=ordered] > .ql-ui:before{
    content:counter(list-0, decimal) '. '
}
.ql-editor li[data-list=ordered].ql-indent-1{
    counter-increment:list-1
}
.ql-editor li[data-list=ordered].ql-indent-1 > .ql-ui:before{
    content:counter(list-1, lower-alpha) '. '
}
@supports (counter-set:none){
    .ql-editor li[data-list].ql-indent-1{
        counter-set:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9
    }
}
@supports not (counter-set:none){
    .ql-editor li[data-list].ql-indent-1{
        counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9
    }
}
.ql-editor li[data-list=ordered].ql-indent-2{
    counter-increment:list-2
}
.ql-editor li[data-list=ordered].ql-indent-2 > .ql-ui:before{
    content:counter(list-2, lower-roman) '. '
}
@supports (counter-set:none){
    .ql-editor li[data-list].ql-indent-2{
        counter-set:list-3 list-4 list-5 list-6 list-7 list-8 list-9
    }
}
@supports not (counter-set:none){
    .ql-editor li[data-list].ql-indent-2{
        counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9
    }
}
.ql-editor li[data-list=ordered].ql-indent-3{
    counter-increment:list-3
}
.ql-editor li[data-list=ordered].ql-indent-3 > .ql-ui:before{
    content:counter(list-3, decimal) '. '
}
@supports (counter-set:none){
    .ql-editor li[data-list].ql-indent-3{
        counter-set:list-4 list-5 list-6 list-7 list-8 list-9
    }
}
@supports not (counter-set:none){
    .ql-editor li[data-list].ql-indent-3{
        counter-reset:list-4 list-5 list-6 list-7 list-8 list-9
    }
}
.ql-editor li[data-list=ordered].ql-indent-4{
    counter-increment:list-4
}
.ql-editor li[data-list=ordered].ql-indent-4 > .ql-ui:before{
    content:counter(list-4, lower-alpha) '. '
}
@supports (counter-set:none){
    .ql-editor li[data-list].ql-indent-4{
        counter-set:list-5 list-6 list-7 list-8 list-9
    }
}
@supports not (counter-set:none){
    .ql-editor li[data-list].ql-indent-4{
        counter-reset:list-5 list-6 list-7 list-8 list-9
    }
}
.ql-editor li[data-list=ordered].ql-indent-5{
    counter-increment:list-5
}
.ql-editor li[data-list=ordered].ql-indent-5 > .ql-ui:before{
    content:counter(list-5, lower-roman) '. '
}
@supports (counter-set:none){
    .ql-editor li[data-list].ql-indent-5{
        counter-set:list-6 list-7 list-8 list-9
    }
}
@supports not (counter-set:none){
    .ql-editor li[data-list].ql-indent-5{
        counter-reset:list-6 list-7 list-8 list-9
    }
}
.ql-editor li[data-list=ordered].ql-indent-6{
    counter-increment:list-6
}
.ql-editor li[data-list=ordered].ql-indent-6 > .ql-ui:before{
    content:counter(list-6, decimal) '. '
}
@supports (counter-set:none){
    .ql-editor li[data-list].ql-indent-6{
        counter-set:list-7 list-8 list-9
    }
}
@supports not (counter-set:none){
    .ql-editor li[data-list].ql-indent-6{
        counter-reset:list-7 list-8 list-9
    }
}
.ql-editor li[data-list=ordered].ql-indent-7{
    counter-increment:list-7
}
.ql-editor li[data-list=ordered].ql-indent-7 > .ql-ui:before{
    content:counter(list-7, lower-alpha) '. '
}
@supports (counter-set:none){
    .ql-editor li[data-list].ql-indent-7{
        counter-set:list-8 list-9
    }
}
@supports not (counter-set:none){
    .ql-editor li[data-list].ql-indent-7{
        counter-reset:list-8 list-9
    }
}
.ql-editor li[data-list=ordered].ql-indent-8{
    counter-increment:list-8
}
.ql-editor li[data-list=ordered].ql-indent-8 > .ql-ui:before{
    content:counter(list-8, lower-roman) '. '
}
@supports (counter-set:none){
    .ql-editor li[data-list].ql-indent-8{
        counter-set:list-9
    }
}
@supports not (counter-set:none){
    .ql-editor li[data-list].ql-indent-8{
        counter-reset:list-9
    }
}
.ql-editor li[data-list=ordered].ql-indent-9{
    counter-increment:list-9
}
.ql-editor li[data-list=ordered].ql-indent-9 > .ql-ui:before{
    content:counter(list-9, decimal) '. '
}
.ql-editor .ql-indent-1:not(.ql-direction-rtl){
    padding-left:3em
}
.ql-editor li.ql-indent-1:not(.ql-direction-rtl){
    padding-left:4.5em
}
.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right{
    padding-right:3em
}
.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right{
    padding-right:4.5em
}
.ql-editor .ql-indent-2:not(.ql-direction-rtl){
    padding-left:6em
}
.ql-editor li.ql-indent-2:not(.ql-direction-rtl){
    padding-left:7.5em
}
.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right{
    padding-right:6em
}
.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right{
    padding-right:7.5em
}
.ql-editor .ql-indent-3:not(.ql-direction-rtl){
    padding-left:9em
}
.ql-editor li.ql-indent-3:not(.ql-direction-rtl){
    padding-left:10.5em
}
.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right{
    padding-right:9em
}
.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right{
    padding-right:10.5em
}
.ql-editor .ql-indent-4:not(.ql-direction-rtl){
    padding-left:12em
}
.ql-editor li.ql-indent-4:not(.ql-direction-rtl){
    padding-left:13.5em
}
.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right{
    padding-right:12em
}
.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right{
    padding-right:13.5em
}
.ql-editor .ql-indent-5:not(.ql-direction-rtl){
    padding-left:15em
}
.ql-editor li.ql-indent-5:not(.ql-direction-rtl){
    padding-left:16.5em
}
.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right{
    padding-right:15em
}
.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right{
    padding-right:16.5em
}
.ql-editor .ql-indent-6:not(.ql-direction-rtl){
    padding-left:18em
}
.ql-editor li.ql-indent-6:not(.ql-direction-rtl){
    padding-left:19.5em
}
.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right{
    padding-right:18em
}
.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right{
    padding-right:19.5em
}
.ql-editor .ql-indent-7:not(.ql-direction-rtl){
    padding-left:21em
}
.ql-editor li.ql-indent-7:not(.ql-direction-rtl){
    padding-left:22.5em
}
.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right{
    padding-right:21em
}
.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right{
    padding-right:22.5em
}
.ql-editor .ql-indent-8:not(.ql-direction-rtl){
    padding-left:24em
}
.ql-editor li.ql-indent-8:not(.ql-direction-rtl){
    padding-left:25.5em
}
.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right{
    padding-right:24em
}
.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right{
    padding-right:25.5em
}
.ql-editor .ql-indent-9:not(.ql-direction-rtl){
    padding-left:27em
}
.ql-editor li.ql-indent-9:not(.ql-direction-rtl){
    padding-left:28.5em
}
.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right{
    padding-right:27em
}
.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right{
    padding-right:28.5em
}
.ql-editor li.ql-direction-rtl{
    padding-right:1.5em
}
.ql-editor li.ql-direction-rtl > .ql-ui:before{
    margin-left:.3em;
    margin-right:-1.5em;
    text-align:left
}
.ql-editor table{
    table-layout:fixed;
    width:100%
}
.ql-editor table td{
    outline:none
}
.ql-editor .ql-code-block-container{
    font-family:monospace
}
.ql-editor .ql-video{
    display:block;
    max-width:100%
}
.ql-editor .ql-video.ql-align-center{
    margin:0 auto
}
.ql-editor .ql-video.ql-align-right{
    margin:0 0 0 auto
}
.ql-editor .ql-bg-black{
    background-color:#000
}
.ql-editor .ql-bg-red{
    background-color:#e60000
}
.ql-editor .ql-bg-orange{
    background-color:#f90
}
.ql-editor .ql-bg-yellow{
    background-color:#ff0
}
.ql-editor .ql-bg-green{
    background-color:#008a00
}
.ql-editor .ql-bg-blue{
    background-color:#06c
}
.ql-editor .ql-bg-purple{
    background-color:#93f
}
.ql-editor .ql-color-white{
    color:#fff
}
.ql-editor .ql-color-red{
    color:#e60000
}
.ql-editor .ql-color-orange{
    color:#f90
}
.ql-editor .ql-color-yellow{
    color:#ff0
}
.ql-editor .ql-color-green{
    color:#008a00
}
.ql-editor .ql-color-blue{
    color:#06c
}
.ql-editor .ql-color-purple{
    color:#93f
}
.ql-editor .ql-font-serif{
    font-family:Georgia,Times New Roman,serif
}
.ql-editor .ql-font-monospace{
    font-family:Monaco,Courier New,monospace
}
.ql-editor .ql-size-small{
    font-size:.75em
}
.ql-editor .ql-size-large{
    font-size:1.5em
}
.ql-editor .ql-size-huge{
    font-size:2.5em
}
.ql-editor .ql-direction-rtl{
    direction:rtl;
    text-align:inherit
}
.ql-editor .ql-align-center{
    text-align:center
}
.ql-editor .ql-align-justify{
    text-align:justify
}
.ql-editor .ql-align-right{
    text-align:right
}
.ql-editor .ql-ui{
    position:absolute
}
.ql-editor.ql-blank::before{
    color: var(--tgui--text_color);
    content:attr(data-placeholder);
    pointer-events:none;
    position:absolute;
    font-size: var(--tgui--text--font_size);
    font-family: var(--tgui--font-family);
    font-weight: 300;
    opacity: .3;
}
.ql-bubble.ql-toolbar:after,.ql-bubble .ql-toolbar:after{
    clear:both;
    content:'';
    display:table
}
.ql-bubble.ql-toolbar button,.ql-bubble .ql-toolbar button{
    background:none;
    border:none;
    cursor:pointer;
    height:34px;
    width:34px;
    display: flex;
    border-radius: 6px;
}
.ql-active {
    background: #2688eb !important;
}
.ql-bubble.ql-toolbar button svg,.ql-bubble .ql-toolbar button svg{
    float:left;
    height:100%
}
.ql-bubble.ql-toolbar button:active:hover,.ql-bubble .ql-toolbar button:active:hover{
    outline:none
}
.ql-bubble.ql-toolbar input.ql-image[type=file],.ql-bubble .ql-toolbar input.ql-image[type=file]{
    display:none
}
.ql-bubble.ql-toolbar button:hover,.ql-bubble .ql-toolbar button:hover,.ql-bubble.ql-toolbar button:focus,.ql-bubble .ql-toolbar button:focus,.ql-bubble.ql-toolbar button.ql-active,.ql-bubble .ql-toolbar button.ql-active,.ql-bubble.ql-toolbar .ql-picker-label:hover,.ql-bubble .ql-toolbar .ql-picker-label:hover,.ql-bubble.ql-toolbar .ql-picker-label.ql-active,.ql-bubble .ql-toolbar .ql-picker-label.ql-active,.ql-bubble.ql-toolbar .ql-picker-item:hover,.ql-bubble .ql-toolbar .ql-picker-item:hover,.ql-bubble.ql-toolbar .ql-picker-item.ql-selected,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected{
    color:#fff
}
.ql-bubble.ql-toolbar button:hover .ql-fill,.ql-bubble .ql-toolbar button:hover .ql-fill,.ql-bubble.ql-toolbar button:focus .ql-fill,.ql-bubble .ql-toolbar button:focus .ql-fill,.ql-bubble.ql-toolbar button.ql-active .ql-fill,.ql-bubble .ql-toolbar button.ql-active .ql-fill,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-fill,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-fill,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-fill,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-fill,.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-bubble.ql-toolbar button:hover .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button:hover .ql-stroke.ql-fill,.ql-bubble.ql-toolbar button:focus .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button:focus .ql-stroke.ql-fill,.ql-bubble.ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill{
    fill:#fff
}
.ql-bubble.ql-toolbar button:hover .ql-stroke,.ql-bubble .ql-toolbar button:hover .ql-stroke,.ql-bubble.ql-toolbar button:focus .ql-stroke,.ql-bubble .ql-toolbar button:focus .ql-stroke,.ql-bubble.ql-toolbar button.ql-active .ql-stroke,.ql-bubble .ql-toolbar button.ql-active .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-bubble.ql-toolbar button:hover .ql-stroke-miter,.ql-bubble .ql-toolbar button:hover .ql-stroke-miter,.ql-bubble.ql-toolbar button:focus .ql-stroke-miter,.ql-bubble .ql-toolbar button:focus .ql-stroke-miter,.ql-bubble.ql-toolbar button.ql-active .ql-stroke-miter,.ql-bubble .ql-toolbar button.ql-active .ql-stroke-miter,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter{
    stroke:#fff
}
@media (pointer:coarse){
    .ql-bubble.ql-toolbar button:hover:not(.ql-active),.ql-bubble .ql-toolbar button:hover:not(.ql-active){
        color:#ccc
    }
    .ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill{
        fill:#ccc
    }
    .ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter{
        stroke:#ccc
    }
}
.ql-bubble{
    box-sizing:border-box
}
.ql-bubble *{
    box-sizing:border-box
}
.ql-bubble .ql-hidden{
    display:none
}
.ql-bubble .ql-out-bottom,.ql-bubble .ql-out-top{
    visibility:hidden
}
.ql-bubble .ql-tooltip{
    position:absolute;
    transform:translateY(10px)
}
.ql-bubble .ql-tooltip a{
    cursor:pointer;
    text-decoration:none
}
.ql-bubble .ql-tooltip.ql-flip{
    transform:translateY(-60px)
}
.ql-bubble .ql-formats{
    display:flex;
    gap: 4px;
}
.ql-bubble .ql-formats:after{
    clear:both;
    content:'';
    display:table
}
.ql-bubble .ql-stroke{
    fill:none;
    stroke:#ccc;
    stroke-linecap:round;
    stroke-linejoin:round;
    stroke-width:2
}
.ql-bubble .ql-stroke-miter{
    fill:none;
    stroke:#ccc;
    stroke-miterlimit:10;
    stroke-width:2
}
.ql-bubble .ql-fill,.ql-bubble .ql-stroke.ql-fill{
    fill:#ccc
}
.ql-bubble .ql-empty{
    fill:none
}
.ql-bubble .ql-even{
    fill-rule:evenodd
}
.ql-bubble .ql-thin,.ql-bubble .ql-stroke.ql-thin{
    stroke-width:1
}
.ql-bubble .ql-transparent{
    opacity:.4
}
.ql-bubble .ql-direction svg:last-child{
    display:none
}
.ql-bubble .ql-direction.ql-active svg:last-child{
    display:inline
}
.ql-bubble .ql-direction.ql-active svg:first-child{
    display:none
}
.ql-bubble .ql-editor h1{
    font-size:2em
}
.ql-bubble .ql-editor h2{
    font-size:1.5em
}
.ql-bubble .ql-editor h3{
    font-size:1.17em
}
.ql-bubble .ql-editor h4{
    font-size:1em
}
.ql-bubble .ql-editor h5{
    font-size:.83em
}
.ql-bubble .ql-editor h6{
    font-size:.67em
}
.ql-bubble .ql-editor a{
    text-decoration:underline
}
.ql-bubble .ql-editor blockquote{
    border-left:4px solid #ccc;
    margin-bottom:5px;
    margin-top:5px;
    padding-left:16px
}
.ql-bubble .ql-editor code,.ql-bubble .ql-editor .ql-code-block-container{
    background-color:#f0f0f0;
    border-radius:3px
}
.ql-bubble .ql-editor .ql-code-block-container{
    margin-bottom:5px;
    margin-top:5px;
    padding:5px 10px
}
.ql-bubble .ql-editor code{
    font-size:85%;
    padding:2px 4px
}
.ql-bubble .ql-editor .ql-code-block-container{
    background-color:#23241f;
    color:#f8f8f2;
    overflow:visible
}
.ql-bubble .ql-editor img{
    max-width:100%
}
.ql-bubble .ql-picker{
    color:#ccc;
    display:inline-block;
    float:left;
    font-size:14px;
    font-weight:500;
    height:24px;
    position:relative;
    vertical-align:middle
}
.ql-bubble .ql-picker-label{
    cursor:pointer;
    display:inline-block;
    height:100%;
    padding-left:8px;
    padding-right:2px;
    position:relative;
    width:100%
}
.ql-bubble .ql-picker-label::before{
    display:inline-block;
    line-height:22px
}
.ql-bubble .ql-picker-options{
    background-color:#444;
    display:none;
    min-width:100%;
    padding:4px 8px;
    position:absolute;
    white-space:nowrap
}
.ql-bubble .ql-picker-options .ql-picker-item{
    cursor:pointer;
    display:block;
    padding-bottom:5px;
    padding-top:5px
}
.ql-bubble .ql-picker.ql-expanded .ql-picker-label{
    color:#777;
    z-index:2
}
.ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-fill{
    fill:#777
}
.ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-stroke{
    stroke:#777
}
.ql-bubble .ql-picker.ql-expanded .ql-picker-options{
    display:block;
    margin-top:-1px;
    top:100%;
    z-index:1
}
.ql-bubble .ql-color-picker,.ql-bubble .ql-icon-picker{
    width:28px
}
.ql-bubble .ql-color-picker .ql-picker-label,.ql-bubble .ql-icon-picker .ql-picker-label{
    padding:2px 4px
}
.ql-bubble .ql-color-picker .ql-picker-label svg,.ql-bubble .ql-icon-picker .ql-picker-label svg{
    right:4px
}
.ql-bubble .ql-icon-picker .ql-picker-options{
    padding:4px 0
}
.ql-bubble .ql-icon-picker .ql-picker-item{
    height:24px;
    width:24px;
    padding:2px 4px
}
.ql-bubble .ql-color-picker .ql-picker-options{
    padding:3px 5px;
    width:152px
}
.ql-bubble .ql-color-picker .ql-picker-item{
    border:1px solid transparent;
    float:left;
    height:16px;
    margin:2px;
    padding:0;
    width:16px
}
.ql-bubble .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg{
    position:absolute;
    margin-top:-9px;
    right:0;
    top:50%;
    width:18px
}
.ql-bubble .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,.ql-bubble .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,.ql-bubble .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,.ql-bubble .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,.ql-bubble .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,.ql-bubble .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before{
    content:attr(data-label)
}
.ql-bubble .ql-picker.ql-header{
    width:98px
}
.ql-bubble .ql-picker.ql-header .ql-picker-label::before,.ql-bubble .ql-picker.ql-header .ql-picker-item::before{
    content:'Normal'
}
.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="1"]::before{
    content:'Heading 1'
}
.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="2"]::before{
    content:'Heading 2'
}
.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="3"]::before{
    content:'Heading 3'
}
.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="4"]::before{
    content:'Heading 4'
}
.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="5"]::before{
    content:'Heading 5'
}
.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="6"]::before{
    content:'Heading 6'
}
.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="1"]::before{
    font-size:2em
}
.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="2"]::before{
    font-size:1.5em
}
.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="3"]::before{
    font-size:1.17em
}
.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="4"]::before{
    font-size:1em
}
.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="5"]::before{
    font-size:.83em
}
.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value="6"]::before{
    font-size:.67em
}
.ql-bubble .ql-picker.ql-font{
    width:108px
}
.ql-bubble .ql-picker.ql-font .ql-picker-label::before,.ql-bubble .ql-picker.ql-font .ql-picker-item::before{
    content:'Sans Serif'
}
.ql-bubble .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=serif]::before{
    content:'Serif'
}
.ql-bubble .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before{
    content:'Monospace'
}
.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=serif]::before{
    font-family:Georgia,Times New Roman,serif
}
.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before{
    font-family:Monaco,Courier New,monospace
}
.ql-bubble .ql-picker.ql-size{
    width:98px
}
.ql-bubble .ql-picker.ql-size .ql-picker-label::before,.ql-bubble .ql-picker.ql-size .ql-picker-item::before{
    content:'Normal'
}
.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=small]::before,.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=small]::before{
    content:'Small'
}
.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=large]::before,.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=large]::before{
    content:'Large'
}
.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=huge]::before{
    content:'Huge'
}
.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=small]::before{
    font-size:10px
}
.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=large]::before{
    font-size:18px
}
.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=huge]::before{
    font-size:32px
}
.ql-bubble .ql-color-picker.ql-background .ql-picker-item{
    background-color:#fff
}
.ql-bubble .ql-color-picker.ql-color .ql-picker-item{
    background-color:#000
}
.ql-code-block-container{
    position:relative
}
.ql-code-block-container .ql-ui{
    right:5px;
    top:5px
}
.ql-toolbar {
    padding: 12px;
}
.ql-tooltip-editor {
    display: flex;
}
.ql-bubble .ql-color-picker svg{
    margin:1px
}
.ql-bubble .ql-color-picker .ql-picker-item.ql-selected,.ql-bubble .ql-color-picker .ql-picker-item:hover{
    border-color:#fff
}
.ql-bubble .ql-tooltip{
    background-color:#444;
    border-radius:12px;
    color:#fff
}
.ql-bubble .ql-tooltip-arrow{
    border-left:6px solid transparent;
    border-right:6px solid transparent;
    content:" ";
    display:none;
    left:50%;
    margin-left:-6px;
    position:absolute
}
.ql-bubble .ql-tooltip:not(.ql-flip) .ql-tooltip-arrow{
    border-bottom:6px solid #444;
    top:-6px
}
.ql-bubble .ql-tooltip.ql-flip .ql-tooltip-arrow{
    border-top:6px solid #444;
    bottom:-6px
}
.ql-bubble .ql-tooltip.ql-editing .ql-tooltip-editor{
    display:flex;
    align-items: center;
    padding: 6px 0;
    flex-wrap: wrap;
}
.ql-close {
    height: 30px;
}
.ql-bubble .ql-tooltip.ql-editing .ql-formats{
    visibility:hidden
}
.ql-bubble .ql-tooltip-editor{
    display:none
}
.ql-editing .ql-toolbar {
    display: none;
}
.ql-bubble .ql-tooltip-editor input[type=text]{
    background:transparent;
    border:none;
    color:#fff;
    font-size:13px;
    height:100%;
    outline:none;
    padding:10px 20px;
    width:100%;
    flex: 0 0 85%;
    padding-right: 10px;
}
.ql-bubble .ql-tooltip-editor a:before{
    color:#ccc;
    content:"\\00D7";
    font-size:22px;
    font-weight:bold
}
.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close){
    position:relative;
    white-space:nowrap
}
.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close)::before{
    background-color:#444;
    border-radius:15px;
    top:-5px;
    font-size:12px;
    color:#fff;
    content:attr(href);
    font-weight:normal;
    overflow:hidden;
    padding:5px 15px;
    text-decoration:none;
    z-index:1
}
.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close)::after{
    border-top:6px solid #444;
    border-left:6px solid transparent;
    border-right:6px solid transparent;
    top:0;
    content:" ";
    height:0;
    width:0
}
.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close)::before,.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close)::after{
    left:0;
    margin-left:50%;
    position:absolute;
    transform:translate(-50%,-100%);
    transition:visibility 0s ease 200ms;
    visibility:hidden!important;
}
.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close):hover::before,.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close):hover::after{
    visibility:visible
}
/*# sourceMappingURL=quill.bubble.css.map*/
`, "",{"version":3,"sources":["webpack://./src/style/bubble.css"],"names":[],"mappings":"AAAA,uJAAuJ;AACvJ;IACI,qBAAqB;IACrB,sCAAsC;IACtC,cAAc;IACd,WAAW;IACX,QAAQ;IACR;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI,cAAc;IACd,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;AACA;IACI,QAAQ;IACR;AACJ;AACA;IACI,qBAAqB;IACrB,mFAAmF;IACnF,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,eAAe;IACf,oBAAoB;IACpB;AACJ;AACA;IACI;AACJ;AACA;IACI,QAAQ;IACR;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;AACJ;AACA;IACI,qBAAqB;IACrB;AACJ;AACA;IACI;AACJ;AACA;IACI,oBAAoB;IACpB,kBAAkB;IAClB;AACJ;AACA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;QACI;IACJ;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB;AACJ;AACA;IACI,kBAAkB;IAClB;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI,aAAa;IACb;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI,aAAa;IACb;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI,8BAA8B;IAC9B,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,uCAAuC;IACvC,qCAAqC;IACrC,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,UAAU;IACV,UAAU;IACV;AACJ;AACA;IACI,eAAe;IACf,WAAW;IACX,cAAc;IACd,WAAW;IACX,UAAU;IACV,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,UAAU;IACV;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI,iBAAiB;IACjB;AACJ;AACA;IACI,cAAc;IACd;AACJ;AACA;IACI;AACJ;AACA;IACI,YAAY;IACZ,QAAQ;AACZ;AACA;IACI,UAAU;IACV,UAAU;IACV;AACJ;AACA;IACI,SAAS;IACT,WAAW;IACX,oBAAoB;IACpB,qBAAqB;IACrB;AACJ;AACA;IACI,SAAS;IACT,WAAW;IACX,oBAAoB;IACpB;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,cAAc;IACd;AACJ;AACA;IACI,wBAAwB;IACxB;AACJ;AACA;IACI,iBAAiB;IACjB,cAAc;IACd;AACJ;AACA;IACI,aAAa;IACb;AACJ;AACA;IACI,wBAAwB;IACxB,aAAa;IACb;AACJ;AACA;IACI;AACJ;AACA;IACI,UAAU;IACV,oBAAoB;IACpB,UAAU;IACV,cAAc;IACd,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB;AACJ;AACA;IACI,cAAc;IACd,oBAAoB;IACpB,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;AACA;IACI,oBAAoB;IACpB;AACJ;AACA;IACI,qBAAqB;IACrB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB;AACJ;AACA;IACI,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB;AACJ;AACA;IACI,UAAU;IACV;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI,WAAW;IACX,UAAU;IACV;AACJ;AACA;IACI,eAAe;IACf;AACJ;AACA;IACI,4BAA4B;IAC5B,UAAU;IACV,WAAW;IACX,UAAU;IACV,SAAS;IACT;AACJ;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,OAAO;IACP,OAAO;IACP;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI,SAAS;IACT;AACJ;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB;AACJ;AACA;IACI,iCAAiC;IACjC,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,gBAAgB;IAChB;AACJ;AACA;IACI,4BAA4B;IAC5B;AACJ;AACA;IACI,yBAAyB;IACzB;AACJ;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,eAAe;AACnB;AACA;IACI,YAAY;AAChB;AACA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI,aAAa;AACjB;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,UAAU;IACV,cAAc;IACd,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,eAAe;IACf,cAAc;IACd;AACJ;AACA;IACI,iBAAiB;IACjB;AACJ;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB;AACJ;AACA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,kCAAkC;IAClC,KAAK;IACL,WAAW;IACX,QAAQ;IACR;AACJ;AACA;IACI,MAAM;IACN,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,mCAAmC;IACnC,2BAA2B;AAC/B;AACA;IACI;AACJ;AACA,0CAA0C","sourcesContent":["/*! * Quill Editor v2.0.3 * https://quilljs.com * Copyright (c) 2017-2024, Slab * Copyright (c) 2014, Jason Chen * Copyright (c) 2013, salesforce.com */\n.ql-container{\n    box-sizing:border-box;\n    font-family:Helvetica,Arial,sans-serif;\n    font-size:13px;\n    height:100%;\n    margin:0;\n    position:relative\n}\n.ql-container.ql-disabled .ql-tooltip{\n    visibility:hidden\n}\n.ql-container:not(.ql-disabled) li[data-list=checked] > .ql-ui,.ql-container:not(.ql-disabled) li[data-list=unchecked] > .ql-ui{\n    cursor:pointer\n}\n.ql-clipboard{\n    left:-100000px;\n    height:1px;\n    overflow-y:hidden;\n    position:absolute;\n    top:50%\n}\n.ql-clipboard p{\n    margin:0;\n    padding:0\n}\n.ql-editor{\n    box-sizing:border-box;\n    counter-reset:list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n    line-height:1.42;\n    height:100%;\n    outline:none;\n    overflow-y:auto;\n    padding:12px 15px;\n    tab-size:4;\n    -moz-tab-size:4;\n    text-align:left;\n    white-space:pre-wrap;\n    word-wrap:break-word\n}\n.ql-editor > *{\n    cursor:text\n}\n.ql-editor p,.ql-editor ol,.ql-editor pre,.ql-editor blockquote,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6{\n    margin:0;\n    padding:0\n}\n@supports (counter-set:none){\n    .ql-editor p,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6{\n        counter-set:list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9\n    }\n}\n@supports not (counter-set:none){\n    .ql-editor p,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6{\n        counter-reset:list-0 list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9\n    }\n}\n.ql-editor table{\n    border-collapse:collapse\n}\n.ql-editor td{\n    border:1px solid #000;\n    padding:2px 5px\n}\n.ql-editor ol{\n    padding-left:1.5em\n}\n.ql-editor li{\n    list-style-type:none;\n    padding-left:1.5em;\n    position:relative\n}\n.ql-editor li > .ql-ui:before{\n    display:inline-block;\n    margin-left:-1.5em;\n    margin-right:.3em;\n    text-align:right;\n    white-space:nowrap;\n    width:1.2em\n}\n.ql-editor li[data-list=checked] > .ql-ui,.ql-editor li[data-list=unchecked] > .ql-ui{\n    color:#777\n}\n.ql-editor li[data-list=bullet] > .ql-ui:before{\n    content:'\\2022'\n}\n.ql-editor li[data-list=checked] > .ql-ui:before{\n    content:'\\2611'\n}\n.ql-editor li[data-list=unchecked] > .ql-ui:before{\n    content:'\\2610'\n}\n@supports (counter-set:none){\n    .ql-editor li[data-list]{\n        counter-set:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9\n    }\n}\n@supports not (counter-set:none){\n    .ql-editor li[data-list]{\n        counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9\n    }\n}\n.ql-editor li[data-list=ordered]{\n    counter-increment:list-0\n}\n.ql-editor li[data-list=ordered] > .ql-ui:before{\n    content:counter(list-0, decimal) '. '\n}\n.ql-editor li[data-list=ordered].ql-indent-1{\n    counter-increment:list-1\n}\n.ql-editor li[data-list=ordered].ql-indent-1 > .ql-ui:before{\n    content:counter(list-1, lower-alpha) '. '\n}\n@supports (counter-set:none){\n    .ql-editor li[data-list].ql-indent-1{\n        counter-set:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9\n    }\n}\n@supports not (counter-set:none){\n    .ql-editor li[data-list].ql-indent-1{\n        counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9\n    }\n}\n.ql-editor li[data-list=ordered].ql-indent-2{\n    counter-increment:list-2\n}\n.ql-editor li[data-list=ordered].ql-indent-2 > .ql-ui:before{\n    content:counter(list-2, lower-roman) '. '\n}\n@supports (counter-set:none){\n    .ql-editor li[data-list].ql-indent-2{\n        counter-set:list-3 list-4 list-5 list-6 list-7 list-8 list-9\n    }\n}\n@supports not (counter-set:none){\n    .ql-editor li[data-list].ql-indent-2{\n        counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9\n    }\n}\n.ql-editor li[data-list=ordered].ql-indent-3{\n    counter-increment:list-3\n}\n.ql-editor li[data-list=ordered].ql-indent-3 > .ql-ui:before{\n    content:counter(list-3, decimal) '. '\n}\n@supports (counter-set:none){\n    .ql-editor li[data-list].ql-indent-3{\n        counter-set:list-4 list-5 list-6 list-7 list-8 list-9\n    }\n}\n@supports not (counter-set:none){\n    .ql-editor li[data-list].ql-indent-3{\n        counter-reset:list-4 list-5 list-6 list-7 list-8 list-9\n    }\n}\n.ql-editor li[data-list=ordered].ql-indent-4{\n    counter-increment:list-4\n}\n.ql-editor li[data-list=ordered].ql-indent-4 > .ql-ui:before{\n    content:counter(list-4, lower-alpha) '. '\n}\n@supports (counter-set:none){\n    .ql-editor li[data-list].ql-indent-4{\n        counter-set:list-5 list-6 list-7 list-8 list-9\n    }\n}\n@supports not (counter-set:none){\n    .ql-editor li[data-list].ql-indent-4{\n        counter-reset:list-5 list-6 list-7 list-8 list-9\n    }\n}\n.ql-editor li[data-list=ordered].ql-indent-5{\n    counter-increment:list-5\n}\n.ql-editor li[data-list=ordered].ql-indent-5 > .ql-ui:before{\n    content:counter(list-5, lower-roman) '. '\n}\n@supports (counter-set:none){\n    .ql-editor li[data-list].ql-indent-5{\n        counter-set:list-6 list-7 list-8 list-9\n    }\n}\n@supports not (counter-set:none){\n    .ql-editor li[data-list].ql-indent-5{\n        counter-reset:list-6 list-7 list-8 list-9\n    }\n}\n.ql-editor li[data-list=ordered].ql-indent-6{\n    counter-increment:list-6\n}\n.ql-editor li[data-list=ordered].ql-indent-6 > .ql-ui:before{\n    content:counter(list-6, decimal) '. '\n}\n@supports (counter-set:none){\n    .ql-editor li[data-list].ql-indent-6{\n        counter-set:list-7 list-8 list-9\n    }\n}\n@supports not (counter-set:none){\n    .ql-editor li[data-list].ql-indent-6{\n        counter-reset:list-7 list-8 list-9\n    }\n}\n.ql-editor li[data-list=ordered].ql-indent-7{\n    counter-increment:list-7\n}\n.ql-editor li[data-list=ordered].ql-indent-7 > .ql-ui:before{\n    content:counter(list-7, lower-alpha) '. '\n}\n@supports (counter-set:none){\n    .ql-editor li[data-list].ql-indent-7{\n        counter-set:list-8 list-9\n    }\n}\n@supports not (counter-set:none){\n    .ql-editor li[data-list].ql-indent-7{\n        counter-reset:list-8 list-9\n    }\n}\n.ql-editor li[data-list=ordered].ql-indent-8{\n    counter-increment:list-8\n}\n.ql-editor li[data-list=ordered].ql-indent-8 > .ql-ui:before{\n    content:counter(list-8, lower-roman) '. '\n}\n@supports (counter-set:none){\n    .ql-editor li[data-list].ql-indent-8{\n        counter-set:list-9\n    }\n}\n@supports not (counter-set:none){\n    .ql-editor li[data-list].ql-indent-8{\n        counter-reset:list-9\n    }\n}\n.ql-editor li[data-list=ordered].ql-indent-9{\n    counter-increment:list-9\n}\n.ql-editor li[data-list=ordered].ql-indent-9 > .ql-ui:before{\n    content:counter(list-9, decimal) '. '\n}\n.ql-editor .ql-indent-1:not(.ql-direction-rtl){\n    padding-left:3em\n}\n.ql-editor li.ql-indent-1:not(.ql-direction-rtl){\n    padding-left:4.5em\n}\n.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right{\n    padding-right:3em\n}\n.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right{\n    padding-right:4.5em\n}\n.ql-editor .ql-indent-2:not(.ql-direction-rtl){\n    padding-left:6em\n}\n.ql-editor li.ql-indent-2:not(.ql-direction-rtl){\n    padding-left:7.5em\n}\n.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right{\n    padding-right:6em\n}\n.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right{\n    padding-right:7.5em\n}\n.ql-editor .ql-indent-3:not(.ql-direction-rtl){\n    padding-left:9em\n}\n.ql-editor li.ql-indent-3:not(.ql-direction-rtl){\n    padding-left:10.5em\n}\n.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right{\n    padding-right:9em\n}\n.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right{\n    padding-right:10.5em\n}\n.ql-editor .ql-indent-4:not(.ql-direction-rtl){\n    padding-left:12em\n}\n.ql-editor li.ql-indent-4:not(.ql-direction-rtl){\n    padding-left:13.5em\n}\n.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right{\n    padding-right:12em\n}\n.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right{\n    padding-right:13.5em\n}\n.ql-editor .ql-indent-5:not(.ql-direction-rtl){\n    padding-left:15em\n}\n.ql-editor li.ql-indent-5:not(.ql-direction-rtl){\n    padding-left:16.5em\n}\n.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right{\n    padding-right:15em\n}\n.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right{\n    padding-right:16.5em\n}\n.ql-editor .ql-indent-6:not(.ql-direction-rtl){\n    padding-left:18em\n}\n.ql-editor li.ql-indent-6:not(.ql-direction-rtl){\n    padding-left:19.5em\n}\n.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right{\n    padding-right:18em\n}\n.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right{\n    padding-right:19.5em\n}\n.ql-editor .ql-indent-7:not(.ql-direction-rtl){\n    padding-left:21em\n}\n.ql-editor li.ql-indent-7:not(.ql-direction-rtl){\n    padding-left:22.5em\n}\n.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right{\n    padding-right:21em\n}\n.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right{\n    padding-right:22.5em\n}\n.ql-editor .ql-indent-8:not(.ql-direction-rtl){\n    padding-left:24em\n}\n.ql-editor li.ql-indent-8:not(.ql-direction-rtl){\n    padding-left:25.5em\n}\n.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right{\n    padding-right:24em\n}\n.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right{\n    padding-right:25.5em\n}\n.ql-editor .ql-indent-9:not(.ql-direction-rtl){\n    padding-left:27em\n}\n.ql-editor li.ql-indent-9:not(.ql-direction-rtl){\n    padding-left:28.5em\n}\n.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right{\n    padding-right:27em\n}\n.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right{\n    padding-right:28.5em\n}\n.ql-editor li.ql-direction-rtl{\n    padding-right:1.5em\n}\n.ql-editor li.ql-direction-rtl > .ql-ui:before{\n    margin-left:.3em;\n    margin-right:-1.5em;\n    text-align:left\n}\n.ql-editor table{\n    table-layout:fixed;\n    width:100%\n}\n.ql-editor table td{\n    outline:none\n}\n.ql-editor .ql-code-block-container{\n    font-family:monospace\n}\n.ql-editor .ql-video{\n    display:block;\n    max-width:100%\n}\n.ql-editor .ql-video.ql-align-center{\n    margin:0 auto\n}\n.ql-editor .ql-video.ql-align-right{\n    margin:0 0 0 auto\n}\n.ql-editor .ql-bg-black{\n    background-color:#000\n}\n.ql-editor .ql-bg-red{\n    background-color:#e60000\n}\n.ql-editor .ql-bg-orange{\n    background-color:#f90\n}\n.ql-editor .ql-bg-yellow{\n    background-color:#ff0\n}\n.ql-editor .ql-bg-green{\n    background-color:#008a00\n}\n.ql-editor .ql-bg-blue{\n    background-color:#06c\n}\n.ql-editor .ql-bg-purple{\n    background-color:#93f\n}\n.ql-editor .ql-color-white{\n    color:#fff\n}\n.ql-editor .ql-color-red{\n    color:#e60000\n}\n.ql-editor .ql-color-orange{\n    color:#f90\n}\n.ql-editor .ql-color-yellow{\n    color:#ff0\n}\n.ql-editor .ql-color-green{\n    color:#008a00\n}\n.ql-editor .ql-color-blue{\n    color:#06c\n}\n.ql-editor .ql-color-purple{\n    color:#93f\n}\n.ql-editor .ql-font-serif{\n    font-family:Georgia,Times New Roman,serif\n}\n.ql-editor .ql-font-monospace{\n    font-family:Monaco,Courier New,monospace\n}\n.ql-editor .ql-size-small{\n    font-size:.75em\n}\n.ql-editor .ql-size-large{\n    font-size:1.5em\n}\n.ql-editor .ql-size-huge{\n    font-size:2.5em\n}\n.ql-editor .ql-direction-rtl{\n    direction:rtl;\n    text-align:inherit\n}\n.ql-editor .ql-align-center{\n    text-align:center\n}\n.ql-editor .ql-align-justify{\n    text-align:justify\n}\n.ql-editor .ql-align-right{\n    text-align:right\n}\n.ql-editor .ql-ui{\n    position:absolute\n}\n.ql-editor.ql-blank::before{\n    color: var(--tgui--text_color);\n    content:attr(data-placeholder);\n    pointer-events:none;\n    position:absolute;\n    font-size: var(--tgui--text--font_size);\n    font-family: var(--tgui--font-family);\n    font-weight: 300;\n    opacity: .3;\n}\n.ql-bubble.ql-toolbar:after,.ql-bubble .ql-toolbar:after{\n    clear:both;\n    content:'';\n    display:table\n}\n.ql-bubble.ql-toolbar button,.ql-bubble .ql-toolbar button{\n    background:none;\n    border:none;\n    cursor:pointer;\n    height:34px;\n    width:34px;\n    display: flex;\n    border-radius: 6px;\n}\n.ql-active {\n    background: #2688eb !important;\n}\n.ql-bubble.ql-toolbar button svg,.ql-bubble .ql-toolbar button svg{\n    float:left;\n    height:100%\n}\n.ql-bubble.ql-toolbar button:active:hover,.ql-bubble .ql-toolbar button:active:hover{\n    outline:none\n}\n.ql-bubble.ql-toolbar input.ql-image[type=file],.ql-bubble .ql-toolbar input.ql-image[type=file]{\n    display:none\n}\n.ql-bubble.ql-toolbar button:hover,.ql-bubble .ql-toolbar button:hover,.ql-bubble.ql-toolbar button:focus,.ql-bubble .ql-toolbar button:focus,.ql-bubble.ql-toolbar button.ql-active,.ql-bubble .ql-toolbar button.ql-active,.ql-bubble.ql-toolbar .ql-picker-label:hover,.ql-bubble .ql-toolbar .ql-picker-label:hover,.ql-bubble.ql-toolbar .ql-picker-label.ql-active,.ql-bubble .ql-toolbar .ql-picker-label.ql-active,.ql-bubble.ql-toolbar .ql-picker-item:hover,.ql-bubble .ql-toolbar .ql-picker-item:hover,.ql-bubble.ql-toolbar .ql-picker-item.ql-selected,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected{\n    color:#fff\n}\n.ql-bubble.ql-toolbar button:hover .ql-fill,.ql-bubble .ql-toolbar button:hover .ql-fill,.ql-bubble.ql-toolbar button:focus .ql-fill,.ql-bubble .ql-toolbar button:focus .ql-fill,.ql-bubble.ql-toolbar button.ql-active .ql-fill,.ql-bubble .ql-toolbar button.ql-active .ql-fill,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-fill,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-fill,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-fill,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-fill,.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-bubble.ql-toolbar button:hover .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button:hover .ql-stroke.ql-fill,.ql-bubble.ql-toolbar button:focus .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button:focus .ql-stroke.ql-fill,.ql-bubble.ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill{\n    fill:#fff\n}\n.ql-bubble.ql-toolbar button:hover .ql-stroke,.ql-bubble .ql-toolbar button:hover .ql-stroke,.ql-bubble.ql-toolbar button:focus .ql-stroke,.ql-bubble .ql-toolbar button:focus .ql-stroke,.ql-bubble.ql-toolbar button.ql-active .ql-stroke,.ql-bubble .ql-toolbar button.ql-active .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-bubble.ql-toolbar button:hover .ql-stroke-miter,.ql-bubble .ql-toolbar button:hover .ql-stroke-miter,.ql-bubble.ql-toolbar button:focus .ql-stroke-miter,.ql-bubble .ql-toolbar button:focus .ql-stroke-miter,.ql-bubble.ql-toolbar button.ql-active .ql-stroke-miter,.ql-bubble .ql-toolbar button.ql-active .ql-stroke-miter,.ql-bubble.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-bubble.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-bubble.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-bubble.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-bubble .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter{\n    stroke:#fff\n}\n@media (pointer:coarse){\n    .ql-bubble.ql-toolbar button:hover:not(.ql-active),.ql-bubble .ql-toolbar button:hover:not(.ql-active){\n        color:#ccc\n    }\n    .ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill{\n        fill:#ccc\n    }\n    .ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-bubble.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,.ql-bubble .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter{\n        stroke:#ccc\n    }\n}\n.ql-bubble{\n    box-sizing:border-box\n}\n.ql-bubble *{\n    box-sizing:border-box\n}\n.ql-bubble .ql-hidden{\n    display:none\n}\n.ql-bubble .ql-out-bottom,.ql-bubble .ql-out-top{\n    visibility:hidden\n}\n.ql-bubble .ql-tooltip{\n    position:absolute;\n    transform:translateY(10px)\n}\n.ql-bubble .ql-tooltip a{\n    cursor:pointer;\n    text-decoration:none\n}\n.ql-bubble .ql-tooltip.ql-flip{\n    transform:translateY(-60px)\n}\n.ql-bubble .ql-formats{\n    display:flex;\n    gap: 4px;\n}\n.ql-bubble .ql-formats:after{\n    clear:both;\n    content:'';\n    display:table\n}\n.ql-bubble .ql-stroke{\n    fill:none;\n    stroke:#ccc;\n    stroke-linecap:round;\n    stroke-linejoin:round;\n    stroke-width:2\n}\n.ql-bubble .ql-stroke-miter{\n    fill:none;\n    stroke:#ccc;\n    stroke-miterlimit:10;\n    stroke-width:2\n}\n.ql-bubble .ql-fill,.ql-bubble .ql-stroke.ql-fill{\n    fill:#ccc\n}\n.ql-bubble .ql-empty{\n    fill:none\n}\n.ql-bubble .ql-even{\n    fill-rule:evenodd\n}\n.ql-bubble .ql-thin,.ql-bubble .ql-stroke.ql-thin{\n    stroke-width:1\n}\n.ql-bubble .ql-transparent{\n    opacity:.4\n}\n.ql-bubble .ql-direction svg:last-child{\n    display:none\n}\n.ql-bubble .ql-direction.ql-active svg:last-child{\n    display:inline\n}\n.ql-bubble .ql-direction.ql-active svg:first-child{\n    display:none\n}\n.ql-bubble .ql-editor h1{\n    font-size:2em\n}\n.ql-bubble .ql-editor h2{\n    font-size:1.5em\n}\n.ql-bubble .ql-editor h3{\n    font-size:1.17em\n}\n.ql-bubble .ql-editor h4{\n    font-size:1em\n}\n.ql-bubble .ql-editor h5{\n    font-size:.83em\n}\n.ql-bubble .ql-editor h6{\n    font-size:.67em\n}\n.ql-bubble .ql-editor a{\n    text-decoration:underline\n}\n.ql-bubble .ql-editor blockquote{\n    border-left:4px solid #ccc;\n    margin-bottom:5px;\n    margin-top:5px;\n    padding-left:16px\n}\n.ql-bubble .ql-editor code,.ql-bubble .ql-editor .ql-code-block-container{\n    background-color:#f0f0f0;\n    border-radius:3px\n}\n.ql-bubble .ql-editor .ql-code-block-container{\n    margin-bottom:5px;\n    margin-top:5px;\n    padding:5px 10px\n}\n.ql-bubble .ql-editor code{\n    font-size:85%;\n    padding:2px 4px\n}\n.ql-bubble .ql-editor .ql-code-block-container{\n    background-color:#23241f;\n    color:#f8f8f2;\n    overflow:visible\n}\n.ql-bubble .ql-editor img{\n    max-width:100%\n}\n.ql-bubble .ql-picker{\n    color:#ccc;\n    display:inline-block;\n    float:left;\n    font-size:14px;\n    font-weight:500;\n    height:24px;\n    position:relative;\n    vertical-align:middle\n}\n.ql-bubble .ql-picker-label{\n    cursor:pointer;\n    display:inline-block;\n    height:100%;\n    padding-left:8px;\n    padding-right:2px;\n    position:relative;\n    width:100%\n}\n.ql-bubble .ql-picker-label::before{\n    display:inline-block;\n    line-height:22px\n}\n.ql-bubble .ql-picker-options{\n    background-color:#444;\n    display:none;\n    min-width:100%;\n    padding:4px 8px;\n    position:absolute;\n    white-space:nowrap\n}\n.ql-bubble .ql-picker-options .ql-picker-item{\n    cursor:pointer;\n    display:block;\n    padding-bottom:5px;\n    padding-top:5px\n}\n.ql-bubble .ql-picker.ql-expanded .ql-picker-label{\n    color:#777;\n    z-index:2\n}\n.ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-fill{\n    fill:#777\n}\n.ql-bubble .ql-picker.ql-expanded .ql-picker-label .ql-stroke{\n    stroke:#777\n}\n.ql-bubble .ql-picker.ql-expanded .ql-picker-options{\n    display:block;\n    margin-top:-1px;\n    top:100%;\n    z-index:1\n}\n.ql-bubble .ql-color-picker,.ql-bubble .ql-icon-picker{\n    width:28px\n}\n.ql-bubble .ql-color-picker .ql-picker-label,.ql-bubble .ql-icon-picker .ql-picker-label{\n    padding:2px 4px\n}\n.ql-bubble .ql-color-picker .ql-picker-label svg,.ql-bubble .ql-icon-picker .ql-picker-label svg{\n    right:4px\n}\n.ql-bubble .ql-icon-picker .ql-picker-options{\n    padding:4px 0\n}\n.ql-bubble .ql-icon-picker .ql-picker-item{\n    height:24px;\n    width:24px;\n    padding:2px 4px\n}\n.ql-bubble .ql-color-picker .ql-picker-options{\n    padding:3px 5px;\n    width:152px\n}\n.ql-bubble .ql-color-picker .ql-picker-item{\n    border:1px solid transparent;\n    float:left;\n    height:16px;\n    margin:2px;\n    padding:0;\n    width:16px\n}\n.ql-bubble .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg{\n    position:absolute;\n    margin-top:-9px;\n    right:0;\n    top:50%;\n    width:18px\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,.ql-bubble .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,.ql-bubble .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before,.ql-bubble .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,.ql-bubble .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,.ql-bubble .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before{\n    content:attr(data-label)\n}\n.ql-bubble .ql-picker.ql-header{\n    width:98px\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label::before,.ql-bubble .ql-picker.ql-header .ql-picker-item::before{\n    content:'Normal'\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]::before,.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before{\n    content:'Heading 1'\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]::before,.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before{\n    content:'Heading 2'\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]::before,.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before{\n    content:'Heading 3'\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]::before,.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before{\n    content:'Heading 4'\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]::before,.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before{\n    content:'Heading 5'\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]::before,.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before{\n    content:'Heading 6'\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before{\n    font-size:2em\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before{\n    font-size:1.5em\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before{\n    font-size:1.17em\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before{\n    font-size:1em\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before{\n    font-size:.83em\n}\n.ql-bubble .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before{\n    font-size:.67em\n}\n.ql-bubble .ql-picker.ql-font{\n    width:108px\n}\n.ql-bubble .ql-picker.ql-font .ql-picker-label::before,.ql-bubble .ql-picker.ql-font .ql-picker-item::before{\n    content:'Sans Serif'\n}\n.ql-bubble .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=serif]::before{\n    content:'Serif'\n}\n.ql-bubble .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before{\n    content:'Monospace'\n}\n.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=serif]::before{\n    font-family:Georgia,Times New Roman,serif\n}\n.ql-bubble .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before{\n    font-family:Monaco,Courier New,monospace\n}\n.ql-bubble .ql-picker.ql-size{\n    width:98px\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-label::before,.ql-bubble .ql-picker.ql-size .ql-picker-item::before{\n    content:'Normal'\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=small]::before,.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=small]::before{\n    content:'Small'\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=large]::before,.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=large]::before{\n    content:'Large'\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=huge]::before{\n    content:'Huge'\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=small]::before{\n    font-size:10px\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=large]::before{\n    font-size:18px\n}\n.ql-bubble .ql-picker.ql-size .ql-picker-item[data-value=huge]::before{\n    font-size:32px\n}\n.ql-bubble .ql-color-picker.ql-background .ql-picker-item{\n    background-color:#fff\n}\n.ql-bubble .ql-color-picker.ql-color .ql-picker-item{\n    background-color:#000\n}\n.ql-code-block-container{\n    position:relative\n}\n.ql-code-block-container .ql-ui{\n    right:5px;\n    top:5px\n}\n.ql-toolbar {\n    padding: 12px;\n}\n.ql-tooltip-editor {\n    display: flex;\n}\n.ql-bubble .ql-color-picker svg{\n    margin:1px\n}\n.ql-bubble .ql-color-picker .ql-picker-item.ql-selected,.ql-bubble .ql-color-picker .ql-picker-item:hover{\n    border-color:#fff\n}\n.ql-bubble .ql-tooltip{\n    background-color:#444;\n    border-radius:12px;\n    color:#fff\n}\n.ql-bubble .ql-tooltip-arrow{\n    border-left:6px solid transparent;\n    border-right:6px solid transparent;\n    content:\" \";\n    display:none;\n    left:50%;\n    margin-left:-6px;\n    position:absolute\n}\n.ql-bubble .ql-tooltip:not(.ql-flip) .ql-tooltip-arrow{\n    border-bottom:6px solid #444;\n    top:-6px\n}\n.ql-bubble .ql-tooltip.ql-flip .ql-tooltip-arrow{\n    border-top:6px solid #444;\n    bottom:-6px\n}\n.ql-bubble .ql-tooltip.ql-editing .ql-tooltip-editor{\n    display:flex;\n    align-items: center;\n    padding: 6px 0;\n    flex-wrap: wrap;\n}\n.ql-close {\n    height: 30px;\n}\n.ql-bubble .ql-tooltip.ql-editing .ql-formats{\n    visibility:hidden\n}\n.ql-bubble .ql-tooltip-editor{\n    display:none\n}\n.ql-editing .ql-toolbar {\n    display: none;\n}\n.ql-bubble .ql-tooltip-editor input[type=text]{\n    background:transparent;\n    border:none;\n    color:#fff;\n    font-size:13px;\n    height:100%;\n    outline:none;\n    padding:10px 20px;\n    width:100%;\n    flex: 0 0 85%;\n    padding-right: 10px;\n}\n.ql-bubble .ql-tooltip-editor a:before{\n    color:#ccc;\n    content:\"\\00D7\";\n    font-size:22px;\n    font-weight:bold\n}\n.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close){\n    position:relative;\n    white-space:nowrap\n}\n.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close)::before{\n    background-color:#444;\n    border-radius:15px;\n    top:-5px;\n    font-size:12px;\n    color:#fff;\n    content:attr(href);\n    font-weight:normal;\n    overflow:hidden;\n    padding:5px 15px;\n    text-decoration:none;\n    z-index:1\n}\n.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close)::after{\n    border-top:6px solid #444;\n    border-left:6px solid transparent;\n    border-right:6px solid transparent;\n    top:0;\n    content:\" \";\n    height:0;\n    width:0\n}\n.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close)::before,.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close)::after{\n    left:0;\n    margin-left:50%;\n    position:absolute;\n    transform:translate(-50%,-100%);\n    transition:visibility 0s ease 200ms;\n    visibility:hidden!important;\n}\n.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close):hover::before,.ql-container.ql-bubble:not(.ql-disabled) a:not(.ql-close):hover::after{\n    visibility:visible\n}\n/*# sourceMappingURL=quill.bubble.css.map*/\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
